import moment from 'moment-timezone';
import dateAndTimeConstants from 'utils/dateAndTimes/constants';

const canBeToday = (timezone = moment.tz.guess()) => {
  const nowMoment = moment().tz(timezone).clone();
  const limitMoment = nowMoment
    .clone()
    .tz(timezone)
    .endOf('day')
    .subtract(
      dateAndTimeConstants.CONSTANTS_FOR_RULES
        .MIN_MARGIN_BEFORE_PICKUP_IN_HOURS,
      'hour'
    )
    .subtract(
      dateAndTimeConstants.CONSTANTS_FOR_RULES.STEPS_IN_MINUTES,
      'minutes'
    );

  return nowMoment.isSameOrBefore(
    limitMoment.clone(),
    'year month week day hour minute'
  );
};

export default canBeToday;
